module.exports = __webpack_public_path__ + "static/img/card_03@2x.3563283.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/card_03@2x.png
// module id = qri9
// module chunks = 0